import { emailOTPClient, genericOAuthClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import { AUTH_URL } from "@/lib/urls";

export const authClient = createAuthClient({
  baseURL: AUTH_URL,
  basePath: "/auth",
  plugins: [emailOTPClient(), genericOAuthClient()],
});

export type Session = typeof authClient.$Infer.Session;
